/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitSubjectView {
	readonly id: number;
	readonly name: string;

	constructor(payload: { id: number; name: string }) {
		this.id = payload.id;
		this.name = payload.name;

		Object.freeze(this);
	}
}

export default AiCostLimitSubjectView;
